import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';

import { ConfirmacaoDaAcao, ResultadoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

export default function ModalReject(props: Props) {
  const modalID = 'validation-reject';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);

  function handleClose() {
    closeModal();
    if (!!success) callback({ id: 'open_feedback' });
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setSuccess(false);
      setIsOpen(true);
    } else {
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (success) {
    return (
      <ResultadoDaAcao title="Ops..." onClose={handleClose}>
        Essa entrega será <strong className="font-bold">devolvida</strong> para que a equipe possa corrigi-la.
      </ResultadoDaAcao>
    );
  }

  return (
    <ConfirmacaoDaAcao
      title="Devolver Realização Destaque"
      onClose={handleClose}
      onConfirm={() => {
        callback({ id: 'reject' });
        setSuccess(true);
      }}
    >
      <p className="m-0">
        Você pode devolver a entrega se ela estiver duplicada ou com conteúdo inadequado. Caso a entrega seja corrigida, você
        poderá avaliá-la novamente. Deseja confirmar essa ação?
      </p>
    </ConfirmacaoDaAcao>
  );
}
